import { weijuIntro } from '@/mocks/weiju';
import Reveal from '@/components/base/Reveal';

export default function WhatIs() {
  return (
    <section id="what" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 border border-accent-200 text-xs md:text-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            味聚是什么
          </div>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            {weijuIntro.title}
          </h2>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-6 space-y-4">
            {weijuIntro.paragraphs.map((p) => (
              <p key={p.slice(0, 12)} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}